import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown24 } from '@onefootprint/icons';
import { Content as CollapsibleContent, Root as CollapsibleRoot, Trigger as CollapsibleTrigger } from '@radix-ui/react-collapsible';
import { cx } from 'class-variance-authority';
import { AnimatePresence, motion } from 'framer-motion';
import type { ComponentType } from 'react';
import { useState } from 'react';
type CollapsibleSectionProps = {
  title: string;
  icon?: ComponentType<{
    className?: string;
  }>;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  wrapperClassName?: string;
};
const CollapsibleSection = t0 => {
  const $ = _c(37);
  const {
    title,
    icon: Icon,
    children,
    defaultOpen: t1,
    className,
    wrapperClassName
  } = t0;
  const defaultOpen = t1 === undefined ? false : t1;
  const [open, setOpen] = useState(defaultOpen);
  let t2;
  if ($[0] !== wrapperClassName) {
    t2 = cx("flex flex-col gap-2 items-start w-full", wrapperClassName);
    $[0] = wrapperClassName;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== wrapperClassName) {
    t3 = cx("flex flex-col rounded-md border border-tertiary w-full", wrapperClassName);
    $[2] = wrapperClassName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== open) {
    t4 = cx("gap-1 p-3 flex items-center justify-between cursor-pointer rounded-md peer transition-colors duration-200", {
      "rounded-b-none": open
    });
    $[4] = open;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== Icon) {
    t5 = Icon && <Icon />;
    $[6] = Icon;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== title) {
    t6 = <p className="text-label-2 text-primary">{title}</p>;
    $[8] = title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="flex items-center gap-1">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== open) {
    t8 = cx("transition-transform duration-200", {
      "-rotate-180": open
    });
    $[13] = open;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <IcoChevronDown24 className={t8} />;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t4 || $[18] !== t7 || $[19] !== t9) {
    t10 = <CollapsibleTrigger className={t4}>{t7}{t9}</CollapsibleTrigger>;
    $[17] = t4;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== children || $[22] !== className || $[23] !== open) {
    t11 = open && <CollapsibleContent forceMount={true} asChild={true}><motion.div className={cx(className)} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }}>{children}</motion.div></CollapsibleContent>;
    $[21] = children;
    $[22] = className;
    $[23] = open;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = <AnimatePresence>{t11}</AnimatePresence>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t12 || $[29] !== t3) {
    t13 = <motion.div layoutRoot={true} className={t3}>{t10}{t12}</motion.div>;
    $[27] = t10;
    $[28] = t12;
    $[29] = t3;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== open || $[32] !== t13) {
    t14 = <CollapsibleRoot open={open} onOpenChange={setOpen} asChild={true}>{t13}</CollapsibleRoot>;
    $[31] = open;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t14 || $[35] !== t2) {
    t15 = <div className={t2}>{t14}</div>;
    $[34] = t14;
    $[35] = t2;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};
export default CollapsibleSection;